import styles from "./CookieConsentAcceptButton.module.css";

export default function CookieConsentAcceptButton(): JSX.Element {
  return (
    <div
      data-icon-only="No"
      data-icon="No"
      data-size="Medium"
      data-state="Default"
      data-type="Primary"
      className={styles.button}
    >
      <div className={styles.text}>Accept</div>
    </div>
  );
}
